import { render } from "./FaqBox.vue?vue&type=template&id=b0aa3266"
import script from "./FaqBox.vue?vue&type=script&lang=js"
export * from "./FaqBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__